<template>
  <a-select
    default-value="-"
    style="width: 100%"
    v-model="value"
    @change="onChange"
    :disabled="isReadOnly"
  >
    <a-select-option value="-">Select Room</a-select-option>
    <a-select-option v-for="room in rooms" :key="room._id" :value="room._id">{{
      room.name
    }}</a-select-option>
  </a-select>
</template>

<script>
import axios from "axios";

export default {
  //
  //
  //
  props: {
    change: { type: Function }
  },
  //
  //
  //
  components: {},
  //
  //
  //
  data() {
    return {
      rooms: [],
      value: "-",
      text: "-",
      isReadOnly: false
    };
  },
  //
  //
  //
  mounted() {
    this.requestData();
  },
  //
  //
  //
  methods: {
    //
    // Request data.
    //
    async requestData() {
      const response = await axios.get(
        process.env.VUE_APP_INVENTORY_API +
          "/rooms/search?allowBooking=Yes&status=Enable",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        }
      );
      this.rooms = response.data.data;
    },
    //
    //
    //
    onChange(value) {
      this.value = value;
      this.text = this.rooms.find(x => x._id === value).name;
      if (this.change !== undefined) {
        this.change(value);
      }
    }
  }
};
</script>

<style lang="scss"></style>
